(function () {
  window.jdgmSettings = window.jdgmSettings || {
    widget_version: '3.0',
    review_widget_revamp_enabled: true,
    widget_load_with_code_splitting: true,
    pagination: 5,
    review_dates: true,
    autopublish: true,
    disable_web_reviews: false,
    shop_currency: 'USD',
    platform: 'shopify',
    locale: document.documentElement.lang || 'en'
  };
  document.documentElement.dataset.jdgmSettingsLoaded = 'true';
})();
